import { z } from 'zod';

/** Valeurs du formulaire « Je déménage ». */
export interface DemenagementValues {
    codePostalA?: string;
    villeA?: string;
    adresseNew: string | null;
    adresse2New: string | null;
    adresse3New: string | null;
    codePostalNew: string;
    villeNew: string;
    addressNotFound?: boolean;
    new_adress_is_new_lieuStationnement: boolean;
    cp_new_lieuStationnement: string;
    ville_new_lieuStationnement: string;
    contrat: number;
    codeProduit?: string;
    sansStationnement: boolean;
}

/** Contrôle du déménagement (ancien `Demenagement/validate.js`) : DOM/TOM et Monaco exclus. */
export const demenagementSchema = z.looseObject({}).superRefine((values, ctx) => {
    const v = values as Partial<DemenagementValues>;

    if (v.codePostalNew && (String(v.codePostalNew).startsWith('97') || String(v.codePostalNew).startsWith('98'))) {
        ctx.addIssue({
            code: 'custom',
            path: ['codePostalNew'],
            message: "Nous ne sommes pas en mesure d'assurer les résidents à Monaco ou dans les DOM/TOM",
        });
    }
});
